import { Component, ElementRef, EventEmitter, Input, NO_ERRORS_SCHEMA, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentService } from '../services/payment.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaymentsNumberValidator } from '../common/payments-number-validator';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';

@Component({
    selector: 'app-payment-amount',
    imports: [ CommonModule, ReactiveFormsModule, ConnectSlideComponent ],
    templateUrl: './payment-amount.component.html',
    styleUrl: './payment-amount.component.scss',
    schemas: [ NO_ERRORS_SCHEMA ]
})

export class PaymentAmountComponent implements OnInit {
    @ViewChild('menu') menuElementRef: ElementRef | undefined;

    @Input() number: string = "";
    @Input() active: string = "";
    @Input() complete: string = "";
    @Output() CompleteEvent = new EventEmitter<void>();
    @Output() TitleClickEvent = new EventEmitter<void>();
    @Input() enterAmountHeading: string = "";
    @Input() enterAmountSubHeading: string = "";
    @Input() enterAmountBody: string = "";
    @Input() continuePaymentButtonText: string = "";

    makePaymentForm: FormGroup | undefined;
    buttonText: string = "";

    constructor(private paymentsService: PaymentService) { }

    ngOnInit() {
        this.makePaymentForm = new FormGroup({
            amount: new FormControl('', [
                Validators.required,
                Validators.min(1),
                Validators.max(5000),
                PaymentsNumberValidator(),
                // PaymentsCvcValidator(),
                // PaymentsCardNameValidator()
            ])
        });

        // this.makePaymentForm.valueChanges.subscribe(val => {
        //     const amount = val.amount;
        //     const amountText = this.makePaymentForm?.controls[ 'amount' ].valid ? this.paymentsService.convertToCurrencyText(amount, true) : null;
        //     console.log('amount' + val);
        //     if (amountText && amount > 0) { this.buttonText = this.continuePaymentButtonText.replace("{amount}", amountText); }
        //     else { this.buttonText = this.continuePaymentButtonText.replace("{amount}", ""); }
        // });

        this.buttonText = this.continuePaymentButtonText.replace("{amount}", "");
    }

    onSubmit() {
        if (this.makePaymentForm?.valid) {
            this.paymentsService.setOrder(this.makePaymentForm.value);
            this.CompleteEvent.emit();
        }
    }


    menuShowHide(type: string) {
        const menuElement = this.menuElementRef?.nativeElement;
        if (type === "blur") {
            menuElement.style.display = ""
        } else {
            menuElement.menuBar.style.display = "none"
        }
    }

    onTitleClick() {
        this.TitleClickEvent.emit();
    }
}
